import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, MailIcon, CheckIcon } from 'lucide-react';
import { Logo } from '../brand/Logo';
import { Button } from '../ui/Button';
import { SERVICE_LINES } from '../../data/services';
import { submitLead } from '../../lib/leads';
const COMPANY_FACTS = ['Cavalla Solution is a consulting firm in augmented intelligence, market intelligence and data led growth.'];
export function Footer() {
  const [email, setEmail] = React.useState('');
  const [status, setStatus] = React.useState<'idle' | 'sending' | 'done'>('idle');
  const [error, setError] = React.useState<string | null>(null);
  const onSubscribe = async (event: React.FormEvent) => {
    event.preventDefault();
    setStatus('sending');
    setError(null);
    const result = await submitLead({
      email,
      consent: true,
      source: 'footer-newsletter'
    });
    if (!result.ok) {
      setError(result.error ?? 'Something went wrong. Please try again.');
      setStatus('idle');
      return;
    }
    setStatus('done');
  };
  return <footer className="surface-dark text-white" data-id="element-99" data-mp="2kbjtz8zca7gk">
      <div className="mx-auto w-full max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-100" data-mp="2p3l2cjtdze1b">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]" data-id="element-101" data-mp="2p5o23vkcclj8">
          <div data-id="element-102" data-mp="2bdzmvjespgy1">
            <Logo variant="reversed" data-id="element-103" data-mp="2babx8vch1eol" />
            <p className="mt-6 max-w-xs text-[15px] text-white/70" data-id="element-104" data-mp="2gazwg4aut1tw">
              Evidence first consulting for organisations that have to make the decision, not just discuss it.
            </p>
            <div className="mt-6 flex items-center gap-4" data-id="element-105" data-mp="3837d34qd0e8a">
              <a href="https://www.linkedin.com/company/cavalla-solution" className="text-white/70 transition-colors hover:text-gold" aria-label="Cavalla Solution on LinkedIn" data-id="element-106" data-mp="380l4d1rqfsoh">
                <LinkedinIcon className="h-5 w-5" aria-hidden="true" data-id="element-107" data-mp="1in7wj2kevmim" />
              </a>
              <a href="mailto:hello@cavallasolution.com" className="text-white/70 transition-colors hover:text-gold" aria-label="Email Cavalla Solution" data-id="element-108" data-mp="1nmkkxrqxl1nb">
                <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-109" data-mp="ziw3jyttg0c5" />
              </a>
            </div>
          </div>

          <nav aria-label="Services" data-id="element-110" data-mp="ur4ksagwiywk">
            <h2 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-111" data-mp="uq2wh4avkfww">Services</h2>
            <ul className="mt-5 space-y-3 text-[15px] text-white/75" data-id="element-112" data-mp="pri5lvhij8l4">
              {SERVICE_LINES.map(line => <li key={line.id} data-id="element-113" data-mp="fveui04onzm1">
                  <Link to={`/services/${line.id}`} className="transition-colors hover:text-white" data-id="element-114" data-mp="fudjtwrkxf4u">
                    {line.name}
                  </Link>
                </li>)}
              <li data-id="element-115" data-mp="6vicuigpo10h">
                <Link to="/government" className="transition-colors hover:text-white" data-id="element-116" data-mp="6w1mzd04dl3y">
                  Cavalla Public Delivery
                </Link>
              </li>
              <li data-id="element-117" data-mp="218840sfp2w46">
                <Link to="/augmented-intelligence" className="transition-colors hover:text-white" data-id="element-118" data-mp="21915pezsqvfg">
                  Our method
                </Link>
              </li>
              <li data-id="element-119" data-mp="2dqbxrs1tgrfg">
                <Link to="/assessment" className="transition-colors hover:text-white" data-id="element-120" data-mp="2dpsrj8lj3rh9">
                  AI readiness assessment
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="Company" data-id="element-121" data-mp="2nflrfccb6i5o">
            <h2 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-122" data-mp="2niq30us3sg6d">Company</h2>
            <ul className="mt-5 space-y-3 text-[15px] text-white/75" data-id="element-123" data-mp="1pvhmle6ylxb8">
              <li data-id="element-124" data-mp="1usrgp75amx5e"><Link to="/insights" className="transition-colors hover:text-white" data-id="element-125" data-mp="1ushttsfjp63x">Insights</Link></li>
              <li data-id="element-126" data-mp="1zq16inwlhatr"><Link to="/resources" className="transition-colors hover:text-white" data-id="element-127" data-mp="1ztf99x967m1q">Resources</Link></li>
              <li data-id="element-128" data-mp="23qtgxkh7dlrm"><Link to="/about" className="transition-colors hover:text-white" data-id="element-129" data-mp="23qtihowupttq">About</Link></li>
              <li data-id="element-130" data-mp="3b8kcr3h4lome"><Link to="/contact" className="transition-colors hover:text-white" data-id="element-131" data-mp="3b8u52xpn87v9">Contact</Link></li>
              <li data-id="element-132" data-mp="3f9xkxk7oy3wh"><Link to="/portal/login" className="transition-colors hover:text-white" data-id="element-133" data-mp="3f9xmhoncabyl">Client login</Link></li>
            </ul>
          </nav>

          <div data-id="element-134" data-mp="38sm7m675vmmr">
            <h2 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-135" data-mp="38t4dlujmlf7v">Fortnightly brief</h2>
            <p className="mt-5 text-[15px] text-white/70" data-id="element-136" data-mp="3nqeop2scwj32">
              One email every two weeks. Market movement, AI adoption and what it means for your sector.
            </p>
            {status === 'done' ? <p className="mt-5 flex items-center gap-2 text-[15px] text-white" data-id="element-137" data-mp="ib21uuc87jr">
                <CheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-138" data-mp="3rqf2qmbjms9l" />
                You are subscribed. Thank you.
              </p> : <form onSubmit={onSubscribe} className="mt-5" data-id="element-139" data-mp="5auayei2yei8">
                <label htmlFor="footer-email" className="sr-only" data-id="element-140" data-mp="5dgl8lwcv845">
                  Your email address
                </label>
                <div className="flex flex-col gap-2 sm:flex-row" data-id="element-141" data-mp="f9tmc4u8co8x">
                  <input id="footer-email" type="email" required value={email} onChange={event => setEmail(event.target.value)} placeholder="you@organisation.org" aria-describedby={error ? 'footer-email-error' : undefined} className="w-full rounded-sm border border-white/25 bg-white/5 px-3 py-2.5 text-[15px] text-white placeholder:text-white/40" data-id="element-142" data-mp="f7gumzyo6zio" />
                  <Button type="submit" size="sm" disabled={status === 'sending'} className="shrink-0" data-id="element-143" data-mp="jyclvum8k5d3">
                    {status === 'sending' ? 'Sending' : 'Subscribe'}
                  </Button>
                </div>
                {error && <p id="footer-email-error" role="alert" className="mt-2 text-small text-gold" data-id="element-144" data-mp="a89gsw1ub0ye">
                    {error}
                  </p>}
                <p className="mt-3 text-small text-white/50" data-id="element-145" data-mp="169z01j03sue">
                  We handle your data in line with our{' '}
                  <Link to="/legal/privacy" className="underline underline-offset-2 hover:text-white" data-id="element-146" data-mp="22y1zsm4rd0a8">
                    privacy notice
                  </Link>
                  .
                </p>
              </form>}
          </div>
        </div>

        <div className="mt-14 border-t border-white/12 pt-8" data-id="element-147" data-mp="1p5vll5l613df">
          <h2 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40" data-id="element-148" data-mp="1p39gdclqyzyd">
            About Cavalla Solution
          </h2>
          <ul className="mt-3 space-y-1.5 text-small text-white/45" data-id="element-149" data-mp="2hthwz00mxcau">
            {COMPANY_FACTS.map(fact => <li key={fact} data-id="element-150" data-mp="2ctdgvb3n2jl5">{fact}</li>)}
          </ul>
        </div>

        <div className="mt-8 flex flex-col gap-4 border-t border-white/12 pt-8 text-small text-white/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-151" data-mp="27wdepb9wu0zb">
          <p data-id="element-152" data-mp="11d5cr58k707d">Copyright {new Date().getFullYear()} Cavalla Solution. All rights reserved.</p>
          <nav aria-label="Legal" className="flex flex-wrap gap-5" data-id="element-153" data-mp="wihxlwzg3i5g">
            <Link to="/legal/privacy" className="hover:text-white" data-id="element-154" data-mp="mdt253ygkhmr">Privacy</Link>
            <Link to="/legal/terms" className="hover:text-white" data-id="element-155" data-mp="rartxfungchs">Terms</Link>
            <Link to="/legal/cookies" className="hover:text-white" data-id="element-156" data-mp="waxslfzc6z9d">Cookies</Link>
          </nav>
        </div>
      </div>
    </footer>;
}